import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { ChartModule } from "primeng/chart";
import { TabMenuModule } from "primeng/tabmenu";
import { MenuItem } from "primeng/api";

import { ChartPageService } from "@features/charts/services/chart-page.service";
import { SubPageComponent } from "@shared/components";
import { GlobalService } from "@shared/services";
import { Subscription } from "rxjs";

@Component({
  selector: "app-chart-page",
  standalone: true,
  imports: [SubPageComponent, ChartModule, TabMenuModule],
  templateUrl: "./chart-page.component.html",
  styleUrl: "./chart-page.component.scss",
})
export class ChartPageComponent implements OnInit, OnDestroy {
  chartPageService = inject(ChartPageService);
  globalService = inject(GlobalService);
  activatedRoute = inject(ActivatedRoute);

  routeSubscription: Subscription | null = null;

  chartData: any;
  chartOptions: any;
  chartTitle: string = "";

  chartType: string = "";

  tabItems: MenuItem[] = [
    {
      label: "History",
      id: "last",
    },
    {
      label: "Plan",
      id: "next",
    },
  ];
  activeItem: MenuItem = this.tabItems[0];
  isPlanData: boolean = false;

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.params.subscribe((params) => {
      this.chartType = params["chartType"];
    });
    const { data, options, chartTitle } = this.chartPageService.getChartConfig(this.chartType, this.isPlanData);
    this.chartData = data;
    this.chartOptions = options;
    this.chartTitle = chartTitle;
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  onTimeframeChange(event: MenuItem) {
    if (event.id === "last") {
      this.isPlanData = false;
    } else {
      this.isPlanData = true;
    }
    this.chartData = this.chartPageService.getChartConfig(this.chartType, this.isPlanData).data;
  }

  getChartHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px - 500px)`;
  }
}
